/* esm.sh - decode-named-character-reference@1.3.0 */
import{characterEntities as r}from"/character-entities@^2.0.0?target=denonext";var t={}.hasOwnProperty;function n(e){return t.call(r,e)?r[e]:!1}export{n as decodeNamedCharacterReference};
//# sourceMappingURL=decode-named-character-reference.mjs.map